import React from "react";
import {
  IonCol,
  IonRow,
  IonTitle,
  IonSpinner,
} from "@ionic/react";
import "../theme/AppStyles.css";




export const LoadingScreen: React.FC<any> = ({ LoadingText }) => {
    return (
        <React.Fragment>
          
          <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow>
            <IonCol></IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="">
            <IonTitle className="splashTxt">WerkApp</IonTitle>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="">
            <IonTitle className="splashTxt2">{LoadingText}</IonTitle>
          </IonCol>
        </IonRow>
          <IonRow>
            <IonCol className="title2">
              <IonSpinner className="backArrowColor" name="dots">
            </IonSpinner>
          </IonCol>
        </IonRow>  
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
        <IonRow></IonRow>
    

        </React.Fragment>
    )
};


